import React from "react";




class Countdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            countdown: '00:00'
        };
        this.timeOuts = null
    }

    componentWillMount() {

    }
    componentDidMount() {
        this.setCountdown()
    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {
        this.timeOuts && clearInterval(this.timeOuts);
        this.timeOuts = null
    }
    setCountdown = () => {
        this.timeOuts && clearInterval(this.timeOuts);
        this.timeOuts = null

        const { times } = this.props
        let time = times || 300;
        //5分钟后时间戳,防止app后台setInterval没有执行，
        let afterMinutes5 = (new Date()).getTime() + (time * 1000)

        let m, s, ms;
        this.timeOuts = setInterval(() => {
            time = parseInt((afterMinutes5 - (new Date().getTime())) / 1000)
            m = parseInt(time / 60).toString();
            s = time - m * 60;
            if (s < 10) {
                s = "0" + s.toString();
            }
            ms = m + ":" + s;
            if (m < 10) { ms = '0' + m.toString() + ":" + s; }
            this.setState({ countdown: ms })

            if (time <= 0) {
                this.timeOuts && clearInterval(this.timeOuts)
                this.timeOuts = null
            }
        }, 1000);
    }

    render() {
        return (
            <>
                <span>{this.state.countdown}</span>
            </>
        );
    }
}



export default Countdown;


